<script>

import FveMixinFieldVueMultiselectMultiple
  from '@fve/Element/Select/FveMixinFieldVueMultiselectMultiple';

export default {
  mixins: [
    FveMixinFieldVueMultiselectMultiple
  ],
};
</script>
